import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { useStyletron } from 'baseui';
import { Card } from 'baseui/card';
import { CardItem } from 'commons-ui';

import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import usePermission from 'routes/usePermission';

import { URL, LABEL, APK_UPDATE_RESOURCES, GET_ACTION, IMAGE_SOURCE } from './helper';

const useApkUpdateHome = () => {
	const { hasPermission } = usePermission();

	const isEnabled = (subEntity: string) => {
		return hasPermission({
			configPageName: PAGE_NAMES.dashboard,
			entity: DASHBOARD_RESOURCES.apkUpdateInfo,
			action: GET_ACTION[subEntity]
		});
	};

	return { isEnabled };
};

const ApkUpdateHome: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { isEnabled } = useApkUpdateHome();

	return (
		<div
			className={css({
				display: 'grid',
				gridTemplateColumns: 'repeat(3, 1fr)',
				gap: '20px',
				padding: '20px',
				justifyItems: 'center',
				alignItems: 'center',
				width: '100%'
			})}>
			{_map(_keys(APK_UPDATE_RESOURCES), (subEntity: string) => {
				return isEnabled(subEntity) ? (
					<div
						key={subEntity}
						className={css({
							height: '130px',
							width: '100%',
							maxWidth: '500px',
							cursor: 'pointer'
						})}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[subEntity]);
						}}>
						<Card
							overrides={{
								Root: {
									style: () => ({
										width: '100%',
										height: '100%'
									})
								},
								Body: {
									component: () => <CardItem label={LABEL[subEntity]} img={IMAGE_SOURCE[subEntity]} />
								}
							}}
						/>
					</div>
				) : null;
			})}
		</div>
	);
};

export default ApkUpdateHome;
